import React from 'react';
import { classNames } from 'primereact/utils';

import EzControlledRadioButton from '../';

const EzControlledRadioButtonWithLabel = (props) => {
  const {
    control,
    name,
    value,
    rules,
    onChange,
    labelClassName,
    wrapperClass,
    label,
    errorMsg,
    isError,
    sectionLabel,
    sectionClassName,
    options,
    containerClassName,
  } = props;

  const renderLabel = () => {
    const lblClass = classNames({ 'p-error': isError }, labelClassName);

    return (
      <label htmlFor={`${name}_${value}`} className={lblClass}>
        {label}
      </label>
    );
  };

  // If options are provided, render multiple radio buttons with section label
  if (options && options.length > 0) {
    return (
      <div className={containerClassName}>
        {sectionLabel && (
          <label className={sectionClassName}>
            {rules?.required ? `${sectionLabel}*` : sectionLabel}
          </label>
        )}
        <div className="d-flex">
          {options.map((option, index) => (
            <div key={option.value} className={wrapperClass}>
              <EzControlledRadioButton
                name={name}
                value={option.value}
                onChange={onChange}
                control={control}
                rules={rules}
              />
              <label htmlFor={`${name}_${option.value}`} className={labelClassName}>
                {option.label}
              </label>
            </div>
          ))}
        </div>
        {errorMsg}
      </div>
    );
  }

  // Single radio button (original functionality)
  return (
    <div className={wrapperClass}>
      <EzControlledRadioButton
        name={name}
        value={value}
        onChange={onChange}
        control={control}
        rules={rules}
      />
      {renderLabel()}
      {errorMsg}
    </div>
  );
};

EzControlledRadioButtonWithLabel.defaultProps = {
  labelClassName: 'ml-2',
  wrapperClass: 'd-flex align-items-center mr-4',
  sectionClassName: 'mb-2',
  containerClassName: 'my-3 w-50 field',
};

export default EzControlledRadioButtonWithLabel;